import { createFileRoute } from '@tanstack/react-router'

import { validateShipmentListSearch } from '#/entities/shipment'
import { OrdersProductPage } from '#/modules/pipelines/pipeline-pages'

export const Route = createFileRoute('/_shell/orders')({
  component: OrdersProductPage,
  validateSearch: validateShipmentListSearch,
})
